import { AutogenModelFreightMatchingControl, AutogenRowFreightMatchingControl } from "./autogen/AutogenModelFreightMatchingControl";

export class ModelFreightMatchingControl extends AutogenModelFreightMatchingControl<RowFreightMatchingControl> {
	constructor() {
		super(RowFreightMatchingControl);
	}
}

export class RowFreightMatchingControl extends AutogenRowFreightMatchingControl {
}